export default "__VITE_ASSET__DPc4S2YC__"